export default __webpack_public_path__ + "static/media/filter.7a7d8dc2.svg";